import {
  auroraFontFamilyMetadata,
  connectFontFamilyMetadata,
  defaultModeratFontFamilyMetadata,
  FontFamilyMetadata,
} from './fontFamilyMetadata'
import { baseAssets, darkModeBaseAssets, selectAssets, selectDarkModeAssets, ThemeAssets } from './theme/assets'
import { auroraAssets, auroraDarkModeAssets } from './theme/auroraAssets'
import { auroraDarkThemeColors, auroraLightThemeColors } from './theme/auroraColors'
import { auroraComponentStyles } from './theme/auroraComponentStyles'
import { darkThemeColors, lightThemeColors, ThemeColors } from './theme/colors'
import { ComponentStyles, defaultComponentStyles } from './theme/componentStyles'
import { connectDarkThemeColors, connectLightThemeColors } from './theme/connectColors'
import { lyraSelectDarkThemeColors, lyraSelectLightThemeColors } from './theme/LyraSelectColors'
import { Theme } from './theme/theme'

export enum PRODUCT_TYPE {
  WFMH = 'WFMH',
  SELECT = 'SELECT',
  CONNECT = 'CONNECT',
}

export const DEFAULT_PRODUCT_TYPE = PRODUCT_TYPE.WFMH

export type ThemeMetadata = {
  colorTokens: ThemeColors
  assets: ThemeAssets
  componentStyles: ComponentStyles
}

type productTypeMetadata = {
  theme: {
    [Theme.DARK]: ThemeMetadata
    [Theme.LIGHT]: ThemeMetadata
  }
  fontFamilyMetadata: FontFamilyMetadata
}

type productTypeToMetadata = {
  [key in PRODUCT_TYPE]: productTypeMetadata
}

export const defaultProductTypesToMetadata: productTypeToMetadata = {
  [PRODUCT_TYPE.WFMH]: {
    theme: {
      [Theme.DARK]: {
        colorTokens: darkThemeColors,
        assets: darkModeBaseAssets,
        componentStyles: defaultComponentStyles,
      },
      [Theme.LIGHT]: {
        colorTokens: lightThemeColors,
        assets: baseAssets,
        componentStyles: defaultComponentStyles,
      },
    },
    fontFamilyMetadata: defaultModeratFontFamilyMetadata,
  },
  [PRODUCT_TYPE.SELECT]: {
    theme: {
      [Theme.DARK]: {
        colorTokens: lyraSelectDarkThemeColors,
        assets: selectDarkModeAssets,
        componentStyles: defaultComponentStyles,
      },
      [Theme.LIGHT]: {
        colorTokens: lyraSelectLightThemeColors,
        assets: selectAssets,
        componentStyles: defaultComponentStyles,
      },
    },
    fontFamilyMetadata: defaultModeratFontFamilyMetadata,
  },
  [PRODUCT_TYPE.CONNECT]: {
    theme: {
      [Theme.DARK]: {
        colorTokens: connectDarkThemeColors,
        assets: auroraDarkModeAssets,
        componentStyles: auroraComponentStyles,
      },
      [Theme.LIGHT]: {
        colorTokens: connectLightThemeColors,
        assets: auroraAssets,
        componentStyles: auroraComponentStyles,
      },
    },
    fontFamilyMetadata: connectFontFamilyMetadata,
  },
}

export const auroraProductTypesToMetadata: productTypeToMetadata = {
  ...defaultProductTypesToMetadata,
  [PRODUCT_TYPE.WFMH]: {
    theme: {
      [Theme.DARK]: {
        colorTokens: auroraDarkThemeColors,
        assets: auroraDarkModeAssets,
        componentStyles: auroraComponentStyles,
      },
      [Theme.LIGHT]: {
        colorTokens: auroraLightThemeColors,
        assets: auroraAssets,
        componentStyles: auroraComponentStyles,
      },
    },
    fontFamilyMetadata: auroraFontFamilyMetadata,
  },
}

export const getProductTypeToMetadata = (isAuroraEnabled: boolean) => {
  return isAuroraEnabled ? auroraProductTypesToMetadata : defaultProductTypesToMetadata
}
